<div class="white-background">
    <div class="d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start">
        <div class="p-4">
            <img class="" ngSrc="/assets/img/logo.png" alt="LOGO" width="340" height="68" />
        </div>

        <div style="" class="tagline">
            <h5 class="text-weight-bold" style="color: #3BA378">
                World’s Most Reliable Certification Manager for
                <i>Competitive</i> Professionals
            </h5>
        </div>
    </div>
    <div class="text-center">
        <img class="mt-2 mb-5" ngSrc="/assets/img/Welcome-to-Your-New-Wallet!.png" alt="" width="374" height="89" />
    </div>
    <div class="container white-background" >
        <mat-card class="shadow-lg card-form">
            <mat-card-content class="rounded-lg text-center">
                <h3 class="my-4" style="color: rgba(204, 85, 0, 1); font-weight: bold">Create New Account</h3>
                <form [formGroup]="form" (ngSubmit)="onSubmit()">
                    <div class="row mt-5">
                        <div class="col-12 text-start">

                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Full Name</mat-label>
                                <input type="text" matInput formControlName="fullName">
                                <mat-icon matPrefix>person</mat-icon>

                                <mat-error *ngIf="form.controls['fullName'].invalid && form.controls['fullName'].errors['required']">Fullname is required</mat-error>

                            </mat-form-field>
                            <mat-error *ngIf="form.controls['fullName'].invalid && resultForm.x && resultForm.x.minlength" >Fullname must be at least 6 characters</mat-error>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="col-12 text-start">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Email Address</mat-label>
                                <input type="text" matInput formControlName="email" >
                                <mat-icon matPrefix>mail</mat-icon>
                                <mat-error *ngIf="f['email'].invalid && f['email'].errors['required']">Email is required</mat-error>
                            </mat-form-field>
                            <mat-error *ngIf="f['email'].invalid && f['email'].errors?.['email']">Email must be a valid email address</mat-error>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="col-12 text-start">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Mobile Number</mat-label>
                                <input type="tel"
                                       matInput
                                       formControlName="mobileNumber"
                                       pattern="^\(\d{3}\)\d{3}-\d{4}$"
                                       [minLength]="10"
                                       [maxLength]="14"
                                       (keyup)="validatePhone()"
                                       mask="(000)-000-0000"
                                       [dropSpecialCharacters]="false"
                                >
                                <mat-icon matPrefix>phone</mat-icon>
                                <mat-error *ngIf="form.controls['mobileNumber'].errors && form.controls['mobileNumber'].errors['required']">Mobile number is required</mat-error>
                            </mat-form-field>

                            <mat-error *ngIf="form.controls['mobileNumber'].errors && f['mobileNumber'].errors['pattern']">Invalid mobile phone number. Format: (XXX)XXX-XXXX</mat-error>
                            <mat-error *ngIf="form.controls['mobileNumber'].errors && resultForm.x && resultForm.x.minlength">Mobile number must be at least 10 characters</mat-error>
                            <mat-error *ngIf="form.controls['mobileNumber'].errors && resultForm.x && resultForm.x.maxlength">Mobile number must be less 14 characters</mat-error>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="col-12 text-start">
                            <mat-form-field appearance="outline" class="w-100 password">
                                <mat-label>Password</mat-label>
                                <input [type]="typePassword ? 'password' : 'text'" matInput formControlName="password"
                                       pattern="(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}">

                                <mat-icon matPrefix>key</mat-icon>

                                <!-- Show Password Suggestion -->
                                <mat-icon [matTooltip]="'Suggest strong password'" matSuffix (click)="showPasswordSuggestion($event)" #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="passwordMenu"
                                          style="cursor: pointer;">lock_reset</mat-icon>

                                <!-- Toggle Password Visibility -->
                                <mat-icon [matTooltip]="typePassword ? 'Show Password' : 'Hide Password'" matSuffix style="cursor: pointer;" (click)="typePassword = !typePassword">
                                    {{ typePassword ? 'visibility' : 'visibility_off' }}
                                </mat-icon>
                            </mat-form-field>

                            <!-- Password Suggestion Menu -->
                            <mat-menu #passwordMenu="matMenu" [overlapTrigger]="false" yPosition="below">
                                <div class="p-3">
                                    <div class="mb-2">Suggested Strong Password</div>
                                    <div class="password-container">
                                        <span>{{ suggestedPassword }}</span>
                                        <mat-icon class="copy-icon" (click)="copyPassword()">content_copy</mat-icon>
                                    </div>

                                </div>
                            </mat-menu>

                            <!-- Password Strength Indicator -->
                            <div class="strength-bar" *ngIf="form.controls['password'].value.length > 0">
                                <div [class]="strengthClass">&nbsp;</div>
                            </div>

                            <!-- Validation Errors -->
                            <mat-error *ngIf="form.controls['password'].errors && f['password'].errors['pattern']">
                                Password must contain number, uppercase, lowercase letter, and special character.
                            </mat-error>
                            <mat-error *ngIf="form.controls['password'].errors && resultForm?.x?.minlength">
                                Password must be at least 8 characters
                            </mat-error>
                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="col-12 mt-4">

                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Referred By</mat-label>
                                <input type="text" matInput formControlName="referredBy">
                                <mat-icon matPrefix>hub</mat-icon>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="form-group mt-4">
                        <p class="text-grey">
                            By continuing, you’re agreeing to our Terms of <br />
                            Understanding, Privacy Policy, and Cookie Policy
                        </p>
                        <div class="mt-2 mb-5">
                            <div class="d-flex justify-content-center mt-2">
                                <button style="margin-right: 10px;"
                                    [disabled]="submitted"
                                    mat-raised-button
                                    class="mt-2 form-button">
                                    Secure My Wallet
                                </button>
                                <button
                                        [disabled]="submitted"
                                        mat-raised-button
                                        class="mt-2 form-button"
                                        type="button"
                                        (click)="goHome()">
                                    Back
                                </button>
                            </div>
                        </div>

                    </div>
                </form>
            </mat-card-content>
        </mat-card>
        <div class="mt-4">
            &nbsp;
        </div>
    </div>
</div>



